import { render, staticRenderFns } from "./Ethics.vue?vue&type=template&id=6405b941&scoped=true"
import script from "./Ethics.vue?vue&type=script&lang=js"
export * from "./Ethics.vue?vue&type=script&lang=js"
import style0 from "./Ethics.vue?vue&type=style&index=0&id=6405b941&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "6405b941",
  null
  
)

export default component.exports